var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.99655 0L6.63324 2.46818H0V3.53182H6.63324L3.99655 6H5.5809L8.4 3.33149V2.6674L5.5809 0H3.99655Z","fill":"#fffef8"}));
}

ArrowRight.defaultProps = {"width":"9","height":"6","viewBox":"0 0 9 6"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
